import React from "react";
import {
  GrayBody,
  GrayCard,
  GrayHeader,
  HeaderButton,
  MobileButton,
  TableContainer,
  TableItem
} from "./style";
import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { GetUser } from "services/user/getUser";

const Billings = () => {
  const navigate = useNavigate();
  const UserData = GetUser();
  const Edit = () => {
    navigate("/settings/manage-subscription");
  };
  return (
    <GrayCard>
      <GrayHeader>
        <Typography size="2xl" weight="medium">
          Billings & Subscription
        </Typography>
        <HeaderButton>
          <PrimaryButton
            onClick={Edit}
            text="MANAGE SUBSCRIPTION"
            fitContent
            variant="border"
            textColor={Colors.white100}
          />
        </HeaderButton>
      </GrayHeader>
      <GrayBody>
        <TableContainer>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Your Plan
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.subscription}
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Status
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              {UserData?.isActive ? "Active" : "Inactive"}
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Next Renewal
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              N/A
            </Typography>
          </TableItem>
          <TableItem>
            <Typography size="xl" color={Colors.grey100} weight="semibold">
              Payment Amount
            </Typography>
            <Typography size="lg" color={Colors.grey500}>
              N/A
            </Typography>
          </TableItem>
        </TableContainer>
        <MobileButton>
          <PrimaryButton
            onClick={Edit}
            text="MANAGE SUBSCRIPTION"
            variant="border"
            textColor={Colors.white100}
          />
        </MobileButton>
      </GrayBody>
    </GrayCard>
  );
};

export default Billings;
